// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1sf16","addWidgetButton":"Header_addWidgetButton__2EHze","dashboardTabs":"Header_dashboardTabs__2i_Rc","active":"Header_active__1A_AJ"};